import React from 'react'
import { Alert } from '@common/material'
import { localizedStrings } from '@core/strings'

interface Messages {
  children?: React.ReactNode
  'data-test'?: string
}

//Generic error message
const Message: React.FC<Messages> = ({ 'data-test': dataTest, children }) => {
  if (!children) {
    return null
  }

  return (
    <>
      <Alert severity='error' data-test={dataTest}>
        {typeof children === 'string'
          ? children.replace(/\n/g, '')
          : localizedStrings.errorProcessingRequest}
      </Alert>
    </>
  )
}

//Default message added alert-danger
export const ErrorMessage: React.FC<Messages> = (props) => (
  <Message {...props} />
)

global.ErrorMessage = ErrorMessage

Message.displayName = 'ErrorMessage'
export default Message
